export type GeoKnowledgeVisualAsset = {
  cover: string;
  bodyImage?: string;
};

export const geoNewsCoverOverrides: Record<string, string> = {
  '454': '/knowledge-assets/443/cover.png',
  '453': '/knowledge-assets/438/cover.png',
  '441': '/knowledge-assets/440/cover.png',
  '439': '/knowledge-assets/437/cover.png',
};

export const applyGeoNewsVisualAssets = <T extends { id: string; cover: string }>(article: T) => ({
  ...article,
  cover: geoNewsCoverOverrides[article.id] ?? article.cover,
});

export const geoKnowledgeVisualAssets: Record<string, GeoKnowledgeVisualAsset> = {
  '404': {
    cover: '/knowledge-assets/404/cover.png',
  },
  '405': {
    cover: '/knowledge-assets/405/cover.png',
  },
  '406': {
    cover: '/knowledge-assets/406/cover.png',
  },
  '407': {
    cover: '/knowledge-assets/407/cover.png',
  },
  '408': {
    cover: '/knowledge-assets/408/cover.png',
  },
  '409': {
    cover: '/knowledge-assets/409/cover.png',
  },
  '410': {
    cover: '/knowledge-assets/410/cover.png',
  },
  '412': {
    cover: '/knowledge-assets/412/cover.png',
    bodyImage: '/knowledge-assets/412/body-1.png',
  },
  '413': {
    cover: '/knowledge-assets/413/cover.png',
    bodyImage: '/knowledge-assets/413/body-1.png',
  },
  '434': {
    cover: '/knowledge-assets/434/cover.png',
    bodyImage: '/knowledge-assets/434/body-1.png',
  },
  '437': {
    cover: '/knowledge-assets/437/cover.png',
    bodyImage: '/knowledge-assets/437/body-1.png',
  },
  '438': {
    cover: '/knowledge-assets/438/cover.png',
    bodyImage: '/knowledge-assets/438/body-1.png',
  },
  '440': {
    cover: '/knowledge-assets/440/cover.png',
    bodyImage: '/knowledge-assets/440/body-1.png',
  },
  '443': {
    cover: '/knowledge-assets/443/cover.png',
    bodyImage: '/knowledge-assets/443/body-1.png',
  },
  '444': {
    cover: '/knowledge-assets/444/cover.png',
    bodyImage: '/knowledge-assets/444/body-1.png',
  },
  '445': {
    cover: '/knowledge-assets/445/cover.png',
    bodyImage: '/knowledge-assets/445/body-1.png',
  },
  '446': {
    cover: '/knowledge-assets/446/cover.png',
    bodyImage: '/knowledge-assets/446/body-1.png',
  },
  '447': {
    cover: '/knowledge-assets/447/cover.png',
    bodyImage: '/knowledge-assets/447/body-1.png',
  },
  '448': {
    cover: '/knowledge-assets/448/cover.png',
    bodyImage: '/knowledge-assets/448/body-1.png',
  },
  '449': {
    cover: '/knowledge-assets/449/cover.png',
    bodyImage: '/knowledge-assets/449/body-1.png',
  },
  '450': {
    cover: '/knowledge-assets/450/aiia-membership.png',
  },
  '451': {
    cover: '/knowledge-assets/451/ranking-reset.png',
  },
};

export const applyGeoKnowledgeVisualAssets = <
  T extends { id: string; cover: string; bodyHtml?: string },
>(
  article: T,
) => {
  const visualAsset = geoKnowledgeVisualAssets[article.id];

  if (!visualAsset) return article;

  const bodyHtml = visualAsset.bodyImage
    ? (article.bodyHtml || '').replace(
        new RegExp(
          `/knowledge-assets/${article.id}/body-1\\.(?:png|jpe?g|webp|gif)`,
          'gi',
        ),
        visualAsset.bodyImage,
      )
    : article.bodyHtml;

  return {
    ...article,
    cover: visualAsset.cover,
    bodyHtml,
  };
};

const geoKnowledgeVisualCoverIds = new Set([
  '404',
  '405',
  '406',
  '407',
  '408',
  '409',
  '410',
  '412',
  '413',
  '434',
  '437',
  '438',
  '440',
  '443',
  '444',
  '445',
  '446',
  '447',
  '448',
  '449',
  '450',
  '451',
  '455',
  '456',
]);

export const hasGeoKnowledgeVisualCover = (id?: string) =>
  Boolean(id && geoKnowledgeVisualCoverIds.has(id));
